import { Component, OnInit } from '@angular/core';

declare let $: any;
declare let jQuery: any;

@Component({
  selector: 'app-sortable-placeholder',
  templateUrl: './sortable-placeholder.component.html',
  styleUrls: ['./sortable-placeholder.component.scss']
})
export class SortablePlaceholderComponent implements OnInit {

  constructor() {
    // $('app-sortable-placeholder').click(() => {
    //   console.log($(this).parent().find('.datatable-header-cell-label draggable'));
    //   $(this).prev().trigger('click');
    // })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/sortable-placeholder/sortable-placeholder.component.ts